<template>
  <div id="app" class="wrap">

  	<cHeader />
  	
  	<bannerSwiper />
  	
  	<centerSwiper />
  	
  	<div class="w panel">
  		<div class="relative clear panel-wrap">
  			<img src="" :data-lazy='require("./images/panel1.png")' class="panel-img"/>
  			
  			<div class="panel-text">
  				<div class="color-103">专为缓解不同程度孕吐研发</div>
  				<ul>
  					<li class="color-151">添加专研天然抑吐成分，纯植物提取</li>
  					<li class="color-151">多款产品，进阶舒适不同孕反程度</li>
  				</ul>
  			</div>
  		</div>
  		<div class="relative clear panel-wrap panel-mg">
  			<img src="" :data-lazy='require("./images/panel2.png")' class="panel-img"/>
  			<div class="panel-text panel-text-next">
  				<div class="color-103">针对孕期不同阶段精准补充营养</div>
  				<ul>
  					<li class="color-151">针对孕早/中/后期所需营养，精准补给</li>
  					<li class="color-151">定制天然营养衣</li>
  					<li class="color-151">纯坚果，不掺果干</li>
  				</ul>
  			</div>
  			
  		</div>
  	</div>
  	
  	
  	<cFooter />
  	
  </div>
</template>

<script>

let that;
import cHeader from '../../components/cHeader.vue';
import cFooter from '../../components/cFooter.vue';
import bannerSwiper from './components/bannerSwiper.vue';
import centerSwiper from './components/centerSwiper.vue';


export default {
  name: 'App',
  data() {
	  return {
	  	windowWidth:this.$utils.windowWidth
	  }
	},
	components:{cHeader,bannerSwiper,centerSwiper,cFooter},
  mounted() {
	  this.$nextTick(function () {
	  	that = this;
			that.$utils.imgLazy();
			that.$utils.animationLazy();
	  })
	},

	methods:{

	}
}
</script>

<style type="text/css">
	
</style>
<style scoped="scoped">
	.panel{padding: 110px 0 240px 0;
	background-image: linear-gradient(to bottom,rgb(243,241,233),rgb(244,232,216));}
	.panel-wrap{width: 74.5%;margin: auto;}
	.panel-img{width: 100%;min-height: 800px;}
	.panel-mg{margin-top: 185px;}
	.panel-text{position: absolute;right: 6%;top: 20%;background: rgba(255,255,255,0.75);border-radius: 20px;
	font-size: 40px;padding: 20px 20px 44px 20px;letter-spacing: 2px;}
	.panel-text-next{right: auto;left: 4.5%;}
	.panel-text li{list-style: disc;font-size: 24px;line-height: 32px;}
	.panel-text ul{padding-left: 30px;margin-top: 18px;}
	
	@media screen and (max-width: 1660px) {
		.panel-img{min-height: 700px;}
		.panel-text{zoom: 0.95;}
	}
	@media screen and (max-width: 1500px) {
		.panel-img{min-height: 500px;}
		.panel-text{zoom: 0.88;}
	}
	@media screen and (max-width: 1300px) {
		.panel-img{min-height: 400px;}
		.panel-text{zoom: 0.82;}
	}
	@media screen and (max-width: 800px) {
		.panel-wrap{width: auto;padding: 10px;}
		.panel-img{min-height: 190px;}
		.panel-text{zoom: 0.48;}
		.panel-mg{margin-top: 25px;}
		.panel{padding:20px 0 20px 0}
	}
</style>
